import { motion } from 'framer-motion';
import { FaEnvelope } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useFullscreen } from '../../contexts/FullscreenContext';

export default function FloatingButtons() {
  const { t } = useTranslation();
  const location = useLocation();
  const isContactPage = location.pathname === '/contact';
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const { isFullscreenActive } = useFullscreen();
  
  // Détecter si l'écran est large (>= 1200px)
  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1200);
    };
    
    // Vérifier la taille initiale
    checkScreenSize();
    
    // Ajouter un écouteur d'événement pour les changements de taille
    window.addEventListener('resize', checkScreenSize);
    
    // Nettoyer l'écouteur d'événement
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  
  // Animation au survol
  const hoverAnimation = {
    scale: 1.1,
    transition: { type: "spring", stiffness: 400, damping: 10 }
  };

  if (isContactPage || isFullscreenActive) {
    return null; // Ne rien afficher sur la page de contact ou en mode plein écran
  }

  return (
    <div className="fixed bottom-8 right-8 z-50 flex flex-col gap-4">
      {/* Bouton Contact */}
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        <Link to="/contact">
          <motion.div
            className={`bg-socabeg-blue text-white ${isLargeScreen ? 'px-6 py-3 justify-start' : 'p-4 justify-center'} rounded-full shadow-lg flex items-center font-semibold`}
            whileHover={hoverAnimation}
          >
            <FaEnvelope className={`text-xl ${isLargeScreen ? 'mr-2' : ''}`} />
            {/* Texte visible uniquement sur les grands écrans */}
            {isLargeScreen && (
              <motion.span
                className="ml-2"
                initial={{ width: 0, opacity: 0 }}
                animate={{ width: 'auto', opacity: 1 }}
                transition={{ delay: 1 }}
              >
                {t('floating.contact')}
              </motion.span>
            )}
            <motion.div
              className="absolute -bottom-1 -right-1 w-6 h-6 bg-white rounded-full flex items-center justify-center text-socabeg-blue font-bold text-xs"
              animate={{ scale: [1, 1.2, 1] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatType: "loop"
              }}
            >
              👋
            </motion.div>
          </motion.div>
        </Link>
      </motion.div>
    </div>
  );
}
